// extracted by mini-css-extract-plugin
var _1 = "KaZZSFRfprFP389jqM1f";
export { _1 as "PowerBiContainer" }
